import React, { useEffect } from "react"
import { graphql } from "gatsby"
import { Layout } from "../../components/Layout"
import { SEO } from "../../components/Seo"
import "./index.scss"
import { FrontMatter } from "../../utils/markdown-types"

export const GitalkContainer = 'gitalk-container';
export const BlogLoadedEvent = 'blog-loaded';

interface BlogPostProps {
    data: {
        markdownRemark: {
            frontmatter: Pick<FrontMatter, "title" | "subTitle" | "tags">
            excerpt: string
            html: string
        }
    }
}

export default ({ data }: BlogPostProps) => {
    const post = data.markdownRemark
    useEffect(() => {
        if (typeof document !== undefined) {
            document.dispatchEvent(new CustomEvent(BlogLoadedEvent))
        }
    }, [])

    return (
        <Layout>
            <SEO
                title={post.frontmatter.title}
                description={
                    post.frontmatter.subTitle || post.excerpt || "nothin’"
                }
                article
                tags={post.frontmatter.tags}
            />
            <h1>{post.frontmatter.title}</h1>
            <div
                className="container"
                dangerouslySetInnerHTML={{ __html: post.html }}
            />
            <div id={GitalkContainer}></div>
        </Layout>
    )
}

export const query = graphql`
    query BlogPostQuery($slug: String!) {
        markdownRemark(fields: { slug: { eq: $slug } }) {
            html
            frontmatter {
                title
                subTitle
                tags
            }
        }
    }
`
